import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import { faFileExport, faLock } from '@fortawesome/pro-solid-svg-icons';
import CallListExportModal from './modal';
import ExportUnavailable from './export_unavailable';
import { type DataExportTemplate } from 'bundles/connect/types';

type Props = {
  callListId: number,
  disabled?: string,
  templates: DataExportTemplate[]
}

export default function CallListExport({ disabled, callListId, templates }: Props) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ExportUnavailable disabled={disabled}>
        <div>
          <Button
            disabled={!!disabled}
            icon={disabled ? faLock : faFileExport}
            label="Export"
            variant="ghost"
            onClick={() => setShowModal(true)}
          />
        </div>

      </ExportUnavailable>
      <CallListExportModal
        callListId={callListId}
        show={showModal}
        templates={templates}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}
